import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  headline: 'By day 4, I took my first 20-minute shower alone.',
  body: ["I didn't change my baby. I changed my structure.", 'The 3-Block Day gave me predictable time without cry-it-out.', 'For the first time, I stopped dreading naps.'],
  name: 'Sarah M.',
  stage: '6 weeks postpartum',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&h=80&fit=crop&crop=face'
}, {
  headline: 'I stopped feeling trapped within a week.',
  body: ['My baby still contact naps. But now I have a system.', 'The Relief Block alone changed my evenings.'],
  name: 'Jennifer K.',
  stage: '2 months postpartum',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face'
}, {
  headline: 'This gave me more relief in 7 days than months of sleep advice.',
  body: ['Other programs focused on my baby. This finally supported ME.', 'Even 15 protected minutes shifted my entire day.'],
  name: 'Patricia L.',
  stage: 'First-time mom, 8 weeks postpartum',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face'
}];
export function Testimonials() {
  return <section className="relative py-16 md:py-24 px-6 md:px-8 bg-cream-dark overflow-hidden" data-id="element-597">
      {/* Subtle ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-sage/4 rounded-full blur-[100px] pointer-events-none" data-id="element-598" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-599">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="text-center mb-20 md:mb-24" data-id="element-600">
          <div className="w-12 h-px bg-terracotta/30 mx-auto mb-6" data-id="element-601" />
          <p className="text-xs uppercase tracking-[0.2em] text-terracotta font-bold mb-4" data-id="element-602">
            Real Mothers. Real Relief.
          </p>
          <h2 className="font-serif text-3xl md:text-5xl text-brown mb-5 leading-tight" data-id="element-603">
            4.9/5 Average Rating from Early Mothers
          </h2>
          <p className="text-brown-light/80 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-604">
            Structured support during the 0–3 month contact nap phase.
          </p>
        </motion.div>

        {/* Cards grid */}
        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mb-24" data-id="element-605">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.8,
          delay: i * 0.1,
          ease: [0.25, 0.1, 0.25, 1]
        }} className="bg-white rounded-2xl p-8 md:p-10 flex flex-col relative border border-brown/5" style={{
          boxShadow: '0 2px 16px rgba(61,50,41,0.04), 0 1px 4px rgba(61,50,41,0.03)'
        }} data-id="element-606">
              {/* Decorative open quote */}
              <div className="absolute top-6 right-8 font-serif text-6xl text-terracotta/10 leading-none select-none pointer-events-none" data-id="element-607">
                "
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-6 relative z-10" data-id="element-608">
                {[...Array(5)].map((_, j) => <svg key={j} className="w-4 h-4 text-terracotta/70 fill-current" viewBox="0 0 20 20" data-id="element-609">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-610" />
                  </svg>)}
              </div>

              {/* Quote headline */}
              <p className="font-serif text-xl md:text-2xl text-brown font-medium leading-snug mb-6 relative z-10" data-id="element-611">
                "{t.headline}"
              </p>

              {/* Body lines */}
              <div className="flex-1 space-y-3 mb-8 relative z-10" data-id="element-612">
                {t.body.map((line, j) => <p key={j} className="text-brown-light/90 text-base leading-relaxed" data-id="element-613">
                    {line}
                  </p>)}
              </div>

              {/* Attribution */}
              <div className="pt-6 border-t border-brown/5 flex items-center gap-4 relative z-10 mt-auto" data-id="element-614">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover ring-2 ring-terracotta/10" data-id="element-615" />
                <div data-id="element-616">
                  <p className="text-brown font-bold text-sm tracking-wide" data-id="element-617">
                    {t.name}
                  </p>
                  <p className="text-brown-light/70 text-xs mt-0.5" data-id="element-618">
                    {t.stage}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Closing line */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="text-center" data-id="element-619">
          <div className="w-12 h-px bg-terracotta/30 mx-auto mb-6" data-id="element-620" />
          <p className="font-serif text-xl md:text-2xl text-brown/60 italic leading-relaxed" data-id="element-621">
            Relief doesn't require perfect naps.
            <br data-id="element-622" />
            It requires structure.
          </p>
        </motion.div>
      </div>
    </section>;
}